import React from "react";
import Container from "react-bootstrap/Container";
import { AnimatedText } from "../components/AnimatedComponents";
import "./Pages.css";

const About = () => (
  <Container>
    <AnimatedText>
      <h1>About</h1>
    </AnimatedText>
  </Container>
);

export default About;
